export const SET_LOADING = 'SET_LOADING';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_EMBEDDED = 'SET_EMBEDDED';
export const SET_SHOW_HEADER = 'SET_SHOW_HEADER';